<template>
  <div class="container" id="goods-edit">
    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <el-breadcrumb separator="">
        <el-breadcrumb-item>
          <div class="div1">商品管理</div>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <div class="div2">运费模板</div>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content">
      <h2>运费模板</h2>
      <div>
        <el-form :inline="true" size="small" label-width="110px">
          <el-form-item label="模板名称" prop="name">
            <el-input placeholder="请输入模板名称" v-model="name"></el-input>
          </el-form-item>
          <el-form-item style="padding-bottom: 10px">
            <el-button type="primary" @click="getList('search')"
              >查询</el-button
            >
            <el-button type="primary" plain @click="getList('reset')"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content">
      <div style="display: flex; justify-content: space-between">
        <h3 style="width: 100%">列表数据</h3>
        <div>
          <el-button type="primary" @click="add('add')">新增模板</el-button>
        </div>
      </div>

      <div style="padding-bottom: 20px; margin-top: 16px">
        <el-card
          style="margin-bottom: 20px"
          class="box-card"
          v-for="(item, index) in models"
          :key="index"
        >
          <div slot="header">
            <span>{{ item.name }}</span>
            <span style="font-size: 14px; margin-left: 20px"
              >最后编辑时间：{{ item.updatedTime }}</span
            >
            <span
              style="font-size: 14px; margin-left: 20px"
              v-if="item.isSync == 1"
              >同步模板</span
            >
            <div style="float: right">
              <!-- <span style="font-size: 14px; margin-right: 10px"
                >最后编辑时间：{{ item.updatedTime }}</span
              > -->
              <el-button type="text" @click="copyModel(item)"
                >复制模板</el-button
              >
              <!-- <el-button
                style="cursor: text"
                type="text"
                v-if="item.isSync == 1"
                >同步模板</el-button
              > -->
              <span
                style="
                  font-size: 14px;
                  color: #409eff;
                  margin-left: 10px;
                  margin-right: 10px;
                "
              ></span>
              <el-button type="text" @click="add('edit', item.id)"
                >编辑</el-button
              >
              <span
                style="
                  font-size: 14px;
                  color: #409eff;
                  margin-left: 10px;
                  margin-right: 10px;
                "
              ></span>
              <el-button type="text" @click="deleteModel(item)">删除</el-button>
            </div>
          </div>
          <div>
            <el-table
              :data="item.list"
              border
              style="width: 100%"
              :header-cell-style="{
                'text-align': 'center',
                background: '#F8F8F9',
              }"
              :cell-style="{ 'text-align': 'center' }"
            >
              <el-table-column prop="date" label="运送方式" width="180">
                <template> 快递 </template>
              </el-table-column>
              <el-table-column prop="betterAddress" label="运送到">
                <template slot-scope="scope">
                  <div v-if="scope.row.address == '全部地区'">全部地区</div>
                  <div v-else>
                    <el-tooltip
                      popper-class="atooltip"
                      effect="dark"
                      :content="scope.row.address"
                      placement="bottom-start"
                    >
                      <div>地区（查看区域）</div>
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="firstNum" label="首件（个）">
                <template slot="header">
                  <div
                    v-if="item.list && item.list[0].calculType == 2"
                    style="text-align: center"
                  >
                    首重（KG）
                  </div>
                  <div v-else style="text-align: center">首件（个）</div>
                </template>
              </el-table-column>
              <el-table-column prop="freight" label="运费（元）">
              </el-table-column>
              <el-table-column prop="addNum" label="续件（个）">
                <template slot="header">
                  <div
                    v-if="item.list && item.list[0].calculType == 2"
                    style="text-align: center"
                  >
                    续重（KG）
                  </div>
                  <div v-else style="text-align: center">续件（个）</div>
                </template>
              </el-table-column>
              <el-table-column prop="addPrice" label="运费（元）">
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {

  },
  data () {
    return {
      name: '',
      dialogUser: false,
      models: [{}, {}],
      tableData: []
    }
  },
  beforeRouteEnter (to, from, next) {
    if (from.name == 'transportationModelEdit') {
      next(vm => {
        vm.getList();
      });
    } else {
      next(vm => {
        vm.getList();
      });
    }
  },

  created () {
    //  this.getList()
  },
  mounted () {
    this.getList()
  },
  methods: {
    getList (type) {
      if (type == 'reset') {
        this.name = ''
      }
      let data = {
        pageNo: 1,
        pageSize: 10000,
        name: this.name,
        isSync: ''
      }
      this.$api.goodsModelList(data).then(res => {
        this.models = res.data.list
      })
    },
    add (type, id) {
      this.$router.push({
        name: 'transportationModelEdit',
        query: {
          type: type,
          id: id
        }
      })
    },
    copyModel (row) {
      const msg = `此操作将复制【${row.name}】模板, 是否继续?`
      this.$confirm(msg, '提示', {
        title: '复制模板',
        confirmButtonText: '确定',
        cancelButtonText: '取消',

      }).then(() => {
        const params = { id: row.id }
        this.$api.goodsModelCopy(params).then((res) => {
          this.getList()
          this.$message({ type: 'success', message: '操作成功!' })
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    syncModel (row) {
      const msg = `此操作将同步【${row.name}】模板, 是否继续?`
      this.$confirm(msg, '提示', {
        title: '同步模板',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        const params = { id: row.id }
        this.$api.goodsModelSync(params).then((res) => {
          this.getList()
          this.$message({ type: 'success', message: '操作成功!' })
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    deleteModel (row) {
      const msg = `此操作将删除【${row.name}】, 是否继续?`
      this.$confirm(msg, '提示', {
        title: '删除模板',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        const params = { id: row.id }
        this.$api.goodsModelDelete(params).then((res) => {
          this.getList()
          this.$message({ type: 'success', message: '操作成功!' })
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
  }
}
</script>
<style lang="scss">
/* 改变三角形颜色 */
/* 朝上 */
.atooltip[x-placement^="bottom"] .popper__arrow:after {
  border-bottom-color: #ffffff;
}
/* 朝下 */
.atooltip[x-placement^="top"] .popper__arrow:after {
  border-top-color: #ffffff;
}
/* 改变三角形外边框 */
/* 三角形朝下的时候 */
.atooltip[x-placement^="bottom"] .popper__arrow {
  border-bottom-color: #ffffff !important;
}
/* 三角形朝上的时候 */
.atooltip[x-placement^="top"] .popper__arrow {
  border-top-color: #ffffff !important;
}
/* 自定义内容的区域的颜色 */
.atooltip {
  width: 319px;
  height: auto;
  background: #ffffff !important;
  box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  border: none;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 30px;
  color: #303033 !important;
}
.el-card__header {
  padding: 0px 0px;
  padding-left: 16px;
  padding-right: 16px;
  height: 49px;
  line-height: 48px;
  background: #f0f5fe !important;
}
.el-card__body {
  padding: 0px !important;
}
</style>
<style scoped>
.div1 {
  margin-left: -16px;
  background: url(../../assets/breadcrumb2.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #2d7edf;
}

.div2 {
  margin-left: -16px;
  background: url(../../assets/breadcrumb1.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #fff;
}
</style>

